import React from "react";
import cx from "classnames";

import "./index.scss";
import { Modal as AntdModal } from "antd";

export const Modal = (props) => {
  return (
    <AntdModal
      {...props}
      wrapProps={{ dir: props.dir }}
      cancelButtonProps={{
        ...props.cancelButtonProps,
        className: cx("secondaryButton", props?.cancelButtonProps?.className),
      }}
      className={cx("primaryModal", props?.className)}
    >
      {props.children}
    </AntdModal>
  );
};
